<template>
  <el-input v-model="mValue" size="mini"></el-input>
</template>
<script>
import { Input } from 'element-ui'

export default {
  components: {
    "ElInput": Input,
  },
  props: ['value'],
  computed: {
    mValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
